/**
 * Every date and time in this app is shown in Netherlands time (CET/CEST), never the viewer's own
 * timezone — the server runs pinned to Europe/Amsterdam (see server/config/tz.ts) and the schedules,
 * cron times and log stamps are all in that clock, so rendering them in a browser's local zone would
 * put the UI an hour or more out of step with the app itself. Always format through these helpers.
 */
export const APP_TZ = "Europe/Amsterdam";

export const fmtDateTime = (d?: string | number | Date | null): string =>
  d ? new Date(d).toLocaleString("nl-NL", { dateStyle: "short", timeStyle: "short", timeZone: APP_TZ }) : "—";

/** Date only, e.g. "4 aug" — for axis labels and other compact spots. */
export const fmtDateShort = (d?: string | number | Date | null): string =>
  d ? new Date(d).toLocaleDateString("nl-NL", { day: "numeric", month: "short", timeZone: APP_TZ }) : "—";

/** Date only, long form, e.g. "4 August 2026". */
export const fmtDateLong = (d?: string | number | Date | null): string =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: APP_TZ }) : "—";

/** Today's date as yyyy-mm-dd in Amsterdam — NOT toISOString(), which is UTC and rolls over an hour early. */
export const todayIso = (): string => new Date().toLocaleDateString("en-CA", { timeZone: APP_TZ });

export const fmtEur = (n?: number | string | null): string => {
  const v = typeof n === "string" ? parseFloat(n) : n;
  return v == null || Number.isNaN(v) ? "—" : `€ ${v.toFixed(2)}`;
};

export const fmtNum = (n?: number | null): string => (n == null ? "—" : n.toLocaleString("nl-NL"));

export function timeAgo(d?: string | Date | null): string {
  if (!d) return "never";
  const ms = Date.now() - new Date(d).getTime();
  const m = Math.round(ms / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
}
